module.exports = __webpack_public_path__ + "img/INTERIOR-S-CROSS-5.3b769a31.jpg";